export enum ImportStatus {
	Completed = 'Completed',
	Failed = 'Failed',
	InProgress = 'In_Progress',
	Waiting = 'Waiting'
}
